import useCompanionAccess from '../hooks/useCompanionAccess';
import { Avatar, Badge, Button as MuiButton, CircularProgress } from '@mui/material';
import { toLower, upperFirst } from 'lodash';
import React, { useEffect, useState } from 'react';
import { Button, Col, Container, Modal, Row } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { pictos } from '../assets/img/pictos';
import Chemin from '../components/Chemin';
import DetailNavigation from '../components/DetailNavigation';
import ErrorPopup from '../components/ErrorPopup';
import Navigation from '../components/Navigation';
import { PoliceDefaut } from '../helpers/contants';
import { sanitizeHtml } from '../helpers/functions';
import { useDelayedLoading } from '../hooks/useDelayedLoading';
import {
  participantSelectRedux,
  programmeSelectRedux,
  supprimerProgrammeMaJournee,
} from '../redux/evenementsServices';
import {
  clearPrefetchedProgrammes,
  removeProgrammeFromMaJournee,
  setPrefetchedProgramme,
  updateCurrentProgrammeIndex,
} from '../redux/evenementsSlice';
import { annulerRdv, envoyerDemandeRedux, refreshToken } from '../redux/profilService';
import { capture } from '../services/analytics';
import '../styles/programme.css';
import textConnect from '../textConnect.json';
import {
  categories,
  couleurTheme,
  formatName,
  formatTimeTo24h,
  pictosCategorie,
} from './fonctions';

const ProgrammeDetail = () => {
  const { requireAccount } = useCompanionAccess();
  const programmeSelected = useSelector(state => state.evenements.programmeSelect);

  const monProfil = useSelector(state => state.profil.profil);
  const evenementSelected = useSelector(state => state.evenements.evenementSelect);

  const accessToken = useSelector(state => state.user.access);
  const refresh_token = useSelector(state => state.user.refresh);

  // Navigation context
  const programmesNavigationIds = useSelector(
    state => state.evenements.programmesNavigationIds || []
  );
  const currentProgrammeIndex = useSelector(state => state.evenements.currentProgrammeIndex ?? -1);
  const prefetchedProgrammes = useSelector(state => state.evenements.prefetchedProgrammes || {});

  const dispatch = useDispatch();
  const navigationPage = useNavigate();

  const param = useParams();

  const [open] = useState(false);
  const [openError, setOpenError] = useState(false);
  const [msgError, setMsgError] = useState('');
  const [cancelLoading, setCancelLoading] = useState(false);
  const [openConfirmCancel, setOpenConfirmCancel] = useState(false);

  const handleCancel = () => {
    if (requireAccount('Ma journée')) return;
    if (!programmeSelected?.id) return;
    setCancelLoading(true);
    setOpenConfirmCancel(false);
    const action =
      param.type === '1'
        ? supprimerProgrammeMaJournee(accessToken, evenementSelected.id, programmeSelected.id)
        : annulerRdv(programmeSelected.id, accessToken);
    action
      .then(() => {
        if (param.type === '1') {
          dispatch(removeProgrammeFromMaJournee(programmeSelected.id));
          navigationPage('/majournee');
        } else {
          navigationPage('/mes-rendez-vous');
        }
      })
      .catch(error => {
        const msg = error?.response?.data?.message || textConnect.error;
        setMsgError(msg);
        setOpenError(true);
      })
      .finally(() => setCancelLoading(false));
  };

  const closeErrorHandle = () => {
    setOpenError(false);
  };

  const [loading, setLoading] = useState(false);
  const showLoading = useDelayedLoading(loading, 250);

  const [netStatus, setNetStatus] = useState(() => {
    if (navigator.onLine) {
      console.log('Connected to network.');
      return true;
    } else {
      return false;
    }
  });

  useEffect(() => {
    window.ononline = e => {
      console.log('Connected to network.');
      setNetStatus(true);
    };
    window.onoffline = e => {
      console.log('Network connection lost.');
      setNetStatus(false);
    };
  }, [netStatus]);

  const participantSelect = (token, id) => {
    if (requireAccount('Fiche participant')) return;
    setLoading(true);
    participantSelectRedux(token, id, evenementSelected.id)
      .then(reponse => {
        dispatch({
          type: 'evenements/addParticipantSelect',
          payload: reponse.data,
        });
        navigationPage(`/compteParticipant/${id}/0`);
        setLoading(false);
        window.scrollTo(0, 0);
      })
      .catch(erreur => {
        if (!netStatus) {
          setMsgError(textConnect.internet);
          setOpenError(true);
        }

        if (erreur.response) {
          if (erreur.response.status !== 401) {
            setMsgError("Une erreur s'est produite.");
            setOpenError(true);
          }
          if (erreur.response.status === 401) {
            refreshToken(refresh_token).then(async reponse => {
              dispatch({
                type: 'user/addRefresh',
                payload: reponse.data.refresh,
              });
              dispatch({
                type: 'user/addAccess',
                payload: reponse.data.access,
              });
              console.log('token refresh...');

              setLoading(false);
              participantSelect(token, id);
            });
          }
        } else {
          setMsgError(textConnect.internet);
          setOpenError(true);
        }
        setLoading(false);
      });
  };
  const location = useLocation();
  const [openEnvoyerDemande, setOpenEnvoyerDemande] = useState(false);
  const [selectProfil, setSelectProfil] = useState('');
  const [circle, setCircle] = useState(false);
  const ouvrirEnvoyer = id => {
    if (requireAccount('Contacts')) return;
    setSelectProfil(id);
    setOpenEnvoyerDemande(true);
  };

  const handleEnvoiDemande = () => {
    setCircle(true);
    envoyerDemandeRedux(accessToken, selectProfil, evenementSelected.id)
      .then(async reponse => {
        // console.log('demande envoyé :', reponse.data)

        await programmeSelectRedux(accessToken, programmeSelected.id).then(reponse => {
          dispatch({
            type: 'evenements/addProgrammeSelect',
            payload: reponse.data,
          });
          // window.open('/programmeDetail', '_top')
        });
        setCircle(false);
        setOpenEnvoyerDemande(false);
        // participantsRedux(accessToken, dispatch, evenementSelected.id)
      })
      .catch(erreur => {
        setCircle(false);
        if (!netStatus) {
          setMsgError(textConnect.internet);
          setOpenError(true);
        }
        if (erreur.response) {
          if (erreur.response.status !== 401) {
            setMsgError(textConnect.error);
            setOpenError(true);
          }
        } else {
          setMsgError(textConnect.internet);
          setOpenError(true);
        }
        if (erreur.response.status === 401) {
          refreshToken(refresh_token).then(async reponse => {
            dispatch({
              type: 'user/addRefresh',
              payload: reponse.data.refresh,
            });
            dispatch({
              type: 'user/addAccess',
              payload: reponse.data.access,
            });
            console.log('token refresh...');

            setLoading(false);
            handleEnvoiDemande();
          });
        }
      });
  };

  // Navigation functions
  const prefetchAdjacentProgrammes = async () => {
    if (programmesNavigationIds.length === 0 || currentProgrammeIndex < 0) {
      return;
    }

    const prevIndex = currentProgrammeIndex - 1;
    const nextIndex = currentProgrammeIndex + 1;

    // Prefetch previous
    if (prevIndex >= 0) {
      const prevId = programmesNavigationIds[prevIndex];
      if (!prefetchedProgrammes[prevId]) {
        try {
          const response = await programmeSelectRedux(accessToken, prevId);
          dispatch(setPrefetchedProgramme({ id: prevId, data: response.data }));
        } catch (error) {
          console.log('Error prefetching previous programme:', error);
        }
      }
    }

    // Prefetch next
    if (nextIndex < programmesNavigationIds.length) {
      const nextId = programmesNavigationIds[nextIndex];
      if (!prefetchedProgrammes[nextId]) {
        try {
          const response = await programmeSelectRedux(accessToken, nextId);
          dispatch(setPrefetchedProgramme({ id: nextId, data: response.data }));
        } catch (error) {
          console.log('Error prefetching next programme:', error);
        }
      }
    }
  };

  const handlePrevious = async () => {
    if (currentProgrammeIndex <= 0 || programmesNavigationIds.length === 0) {
      return;
    }

    const prevIndex = currentProgrammeIndex - 1;
    const prevId = programmesNavigationIds[prevIndex];

    const typeParam = param.type ?? '0';
    if (prefetchedProgrammes[prevId]) {
      dispatch({
        type: 'evenements/addProgrammeSelect',
        payload: prefetchedProgrammes[prevId],
      });
      navigationPage(`/programme/${prevId}/${typeParam}`);
      window.scrollTo(0, 0);
    } else {
      setLoading(true);
      try {
        const response = await programmeSelectRedux(accessToken, prevId);
        dispatch({
          type: 'evenements/addProgrammeSelect',
          payload: response.data,
        });
        navigationPage(`/programme/${prevId}/${typeParam}`);
        window.scrollTo(0, 0);
      } catch (error) {
        console.log('Error navigating to previous:', error);
      } finally {
        setLoading(false);
      }
    }

    dispatch(updateCurrentProgrammeIndex(prevIndex));
  };

  const handleNext = async () => {
    if (
      currentProgrammeIndex >= programmesNavigationIds.length - 1 ||
      programmesNavigationIds.length === 0
    ) {
      return;
    }

    const nextIndex = currentProgrammeIndex + 1;
    const nextId = programmesNavigationIds[nextIndex];
    const typeParam = param.type ?? '0';

    if (prefetchedProgrammes[nextId]) {
      dispatch({
        type: 'evenements/addProgrammeSelect',
        payload: prefetchedProgrammes[nextId],
      });
      navigationPage(`/programme/${nextId}/${typeParam}`);
      window.scrollTo(0, 0);
    } else {
      setLoading(true);
      try {
        const response = await programmeSelectRedux(accessToken, nextId);
        dispatch({
          type: 'evenements/addProgrammeSelect',
          payload: response.data,
        });
        navigationPage(`/programme/${nextId}/${typeParam}`);
        window.scrollTo(0, 0);
      } catch (error) {
        console.log('Error navigating to next:', error);
      } finally {
        setLoading(false);
      }
    }

    dispatch(updateCurrentProgrammeIndex(nextIndex));
  };

  useEffect(() => {
    if (programmeSelected?.id) {
      capture('program_viewed', { programme_id: programmeSelected.id });
    }
  }, [programmeSelected?.id]);

  // Prefetch adjacent programmes
  useEffect(() => {
    if (
      programmeSelected &&
      programmeSelected.id &&
      programmesNavigationIds.length > 0 &&
      currentProgrammeIndex >= 0
    ) {
      prefetchAdjacentProgrammes();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [programmeSelected?.id, currentProgrammeIndex]);

  // Clear prefetch cache when leaving
  useEffect(() => {
    return () => {
      if (programmesNavigationIds.length === 0) {
        dispatch(clearPrefetchedProgrammes());
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  //Breadcrumbs
  const breadCrumbs = useSelector(state => state.profil.chemin);
  const breadcrumbs_temp = breadCrumbs.filter(item => item.nom === 'Accueil');
  breadcrumbs_temp.push({
    url:
      param.type === '2' ? '/mes-rendez-vous' : param.type === '0' ? '/programmes' : '/majournee',
    nom: param.type === '2' ? 'Mes rendez-vous' : param.type === '0' ? 'Programme' : 'Ma journée',
  });
  if (programmeSelected.titre) {
    breadcrumbs_temp.push({
      url: location.pathname,
      nom: upperFirst(toLower(programmeSelected.titre)),
    });
  }

  useEffect(() => {
    if (programmeSelected.titre) {
      dispatch({
        type: 'Profil/addChemin',
        payload: breadcrumbs_temp,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [programmeSelected]);
  const [indexPart, setIndexPart] = useState([]);
  useEffect(() => {
    if (selectProfil !== '') {
      setIndexPart(old => [...old, selectProfil.toString()]);
    }
  }, [selectProfil]);

  return (
    <Container fluid>
      {/* <button onClick={() => console.log(location.pathname.split('/'))}>location</button> */}
      <Modal
        className="d-flex align-items-center"
        show={openEnvoyerDemande}
        onHide={() => setOpenEnvoyerDemande(false)}
        style={{ fontFamily: PoliceDefaut }}
      >
        <Modal.Header
          closeVariant="white"
          closeButton
          style={{ color: 'white', backgroundColor: '#134491' }}
        >
          <h4>Confirmation</h4>
        </Modal.Header>
        <form>
          <Modal.Body>
            Voulez-vous vraiment envoyer une demande ?
            <div className="d-flex justify-content-end mt-3">
              {circle ? (
                <CircularProgress />
              ) : (
                <Button className="btn-recup" onClick={() => handleEnvoiDemande()}>
                  Confirmer
                </Button>
              )}

              <Button
                className="btn-recup2 mx-2"
                variant="secondary"
                onClick={() => setOpenEnvoyerDemande(false)}
              >
                Fermer
              </Button>
            </div>
          </Modal.Body>
        </form>
      </Modal>
      <ErrorPopup message={msgError} open={openError} close={() => closeErrorHandle()} />
      <Row>
        <Navigation
          button={true}
          titre={
            param.type === '2' ? 'Mes rendez-vous' : param.type === '0' ? 'Programme' : 'Ma journée'
          }
          icone={
            param.type === '2'
              ? pictos.mes_rendez_vous_rond_icone
              : param.type === '0'
              ? pictos.programme_rond_icone
              : pictos.journee_rond_icone
          }
          evenement={evenementSelected.photo}
          photo={monProfil.photo_path}
          retour="dashboard"
          selected={param.type === '2' ? 3 : param.type === '0' ? 5 : 4}
          open={(!open).toString()}
          menus={true}
        />
        {/* <NavbarParticipants button={true} titre={'Programme'} icone={pictos.programme_icone} evenement={evenementSelected.photo} photo={monProfil.photo_path} /> */}
      </Row>
      <Row className="p-0">
        <Chemin breadCrumbs={breadcrumbs_temp} />
      </Row>
      {programmesNavigationIds.length > 0 &&
        (param.type === '0' || param.type === '1' || param.type === '2') && (
          <DetailNavigation
            currentIndex={currentProgrammeIndex}
            totalCount={programmesNavigationIds.length}
            onPrevious={handlePrevious}
            onNext={handleNext}
            loading={loading}
            hideCounter={true}
          />
        )}
      <Row className="programme-container">
        <Col>
          <Row className="programme-detail">
            <Col>
              <Row className="d-flex align-items-center mb-2 ">
                <Col
                  sm={'auto'}
                  className="programme-date mt-2 mx-2"
                  style={{
                    backgroundColor: couleurTheme(programmeSelected.categorie),
                    color: 'white',
                    width: 'fit-content',
                  }}
                >
                  {' '}
                  {programmeSelected.heure_fin === null ||
                  programmeSelected.heure_fin === undefined ||
                  programmeSelected.heure_fin === ''
                    ? formatTimeTo24h(programmeSelected.heure_deb)
                    : `${formatTimeTo24h(programmeSelected.heure_deb)} - ${formatTimeTo24h(
                        programmeSelected.heure_fin
                      )}`}{' '}
                </Col>
                {/* <Col xs={''} className='text-uppercase' style={{ color: couleurTheme(programmeSelected.categorie.couleur) }}>{programmeSelected.theme}</Col> */}
                <Col className="stand1 pt-2" style={{ padding: '0' }}>
                  {programmeSelected.categorie.for_room ? (
                    (programmeSelected.stand.id === '' ||
                      programmeSelected.stand.id === undefined) &&
                    programmeSelected.salle === '' ? null : (
                      <div className="d-flex align-items-end">
                        <img
                          title={
                            programmeSelected.stand.code === undefined ||
                            programmeSelected.stand.id === ''
                              ? ''
                              : 'Voir le stand'
                          }
                          onClick={() =>
                            navigationPage(
                              programmeSelected.stand.code === undefined ||
                                programmeSelected.stand.id === ''
                                ? ''
                                : '/planStand/' + programmeSelected.stand.id
                            )
                          }
                          src={pictos.lieu_icone}
                          alt=""
                          style={{
                            height: '25px',
                            width: 'auto',
                            cursor:
                              programmeSelected.stand.code === undefined ||
                              programmeSelected.stand.id === ''
                                ? ''
                                : 'pointer',
                          }}
                        />
                        <div>{upperFirst(toLower(programmeSelected.salle))}</div>
                      </div>
                    )
                  ) : programmeSelected.stand.code === undefined ||
                    programmeSelected.stand.code === '' ? null : (
                    <div className="d-flex align-items-end">
                      <img
                        title="Voir le stand"
                        onClick={() =>
                          navigationPage(
                            programmeSelected.stand.id === undefined ||
                              programmeSelected.stand.id === ''
                              ? ''
                              : '/planStand/' + programmeSelected.stand.id
                          )
                        }
                        src={pictos.lieu_icone}
                        alt=""
                        style={{
                          height: '25px',
                          width: 'auto',
                          cursor: 'pointer',
                        }}
                      />
                      <div>{upperFirst(toLower(programmeSelected.stand.code))}</div>
                    </div>
                  )}
                </Col>
                <Col
                  sm="auto"
                  className=" d-flex justify-content-end"
                  style={{ width: 'fit-content' }}
                >
                  <img
                    className="col-sm-auto mt-1"
                    src={pictosCategorie(programmeSelected.categorie)}
                    alt=""
                    style={{ height: '50px' }}
                  />
                </Col>
              </Row>
              <Row className="mb-1" style={{ marginTop: '-12px' }}>
                <Row className="stand2" style={{}}>
                  <Col className=" p-0  mb-1 px-1" style={{ width: '' }}>
                    {programmeSelected.categorie.for_room ? (
                      (programmeSelected.stand.id === '' ||
                        programmeSelected.stand.id === undefined) &&
                      programmeSelected.salle === '' ? null : (
                        <div className="d-flex align-items-end">
                          <img
                            title={
                              programmeSelected.stand.code === undefined ||
                              programmeSelected.stand.id === ''
                                ? ''
                                : 'Voir le stand'
                            }
                            onClick={() =>
                              navigationPage(
                                programmeSelected.stand.code === undefined ||
                                  programmeSelected.stand.id === ''
                                  ? ''
                                  : '/planStand/' + programmeSelected.stand.id
                              )
                            }
                            src={pictos.lieu_icone}
                            alt=""
                            style={{
                              height: '25px',
                              width: 'auto',
                              cursor:
                                programmeSelected.stand.code === undefined ||
                                programmeSelected.stand.id === ''
                                  ? ''
                                  : 'pointer',
                            }}
                          />
                          <div>{upperFirst(toLower(programmeSelected.salle))}</div>
                        </div>
                      )
                    ) : programmeSelected.stand.code === undefined ||
                      programmeSelected.stand.code === '' ? null : (
                      <div className="d-flex align-items-end">
                        <img
                          title="Voir le stand"
                          onClick={() =>
                            navigationPage(
                              programmeSelected.stand.id === undefined ||
                                programmeSelected.stand.id === ''
                                ? ''
                                : '/planStand/' + programmeSelected.stand.id
                            )
                          }
                          src={pictos.lieu_icone}
                          alt=""
                          style={{
                            height: '25px',
                            width: 'auto',
                            cursor: 'pointer',
                          }}
                        />
                        <div>{upperFirst(toLower(programmeSelected.stand.code))}</div>
                      </div>
                    )}
                  </Col>
                </Row>
                <Col
                  sm="auto"
                  className="mb-2"
                  style={{ color: couleurTheme(programmeSelected.categorie) }}
                >
                  {programmeSelected.theme === undefined ||
                  programmeSelected.theme === '' ||
                  programmeSelected.theme === null
                    ? `${upperFirst(toLower(programmeSelected.categorie.label))}`
                    : programmeSelected.categorie.label === '' ||
                      programmeSelected.categorie.label === null ||
                      programmeSelected.categorie.label === 'Rendez-vous'
                    ? `${upperFirst(toLower(programmeSelected.theme))}`
                    : `${upperFirst(toLower(programmeSelected.categorie.label))} - ${upperFirst(
                        toLower(programmeSelected.theme)
                      )}`}
                </Col>
              </Row>
              <Row>
                <Col
                  className="programme-titre"
                  style={{ color: couleurTheme(programmeSelected.categorie) }}
                >
                  {upperFirst(toLower(programmeSelected.titre))}
                </Col>
              </Row>
              <Row className="" style={{ textAlign: '' }}>
                <Col
                  className="programme-description-text programme-description-html"
                  style={{ wordBreak: 'break-word' }}
                  dangerouslySetInnerHTML={{
                    __html: sanitizeHtml(programmeSelected.description || ''),
                  }}
                />
              </Row>
              <Row
                className=""
                style={{ borderTop: '2px solid #1cace4', marginLeft: '2px', marginTop: '1rem' }}
              >
                <Container className="intervenants-container">
                  {programmeSelected.intervenants.length ? (
                    <Row className="font-weight-bold mb-2 h5 mt-2" style={{ color: '#1cace4' }}>
                      Participants
                    </Row>
                  ) : null}
                  {showLoading ? (
                    <div className="d-flex justify-content-center p-4">
                      <CircularProgress />
                    </div>
                  ) : (
                    programmeSelected.intervenants.map((item, index) => (
                      <Row key={index} className=" intervenant-item d-flex align-items-center">
                        <Col
                          onClick={() =>
                            item.id === monProfil.id ? '' : participantSelect(accessToken, item.id)
                          }
                          sm="auto"
                          className="photo-profil-participant "
                          style={{ cursor: 'pointer' }}
                        >
                          <Badge
                            className="d-flex align-items-center justify-content-left"
                            style={{ width: 'fit-content' }}
                            overlap="circular"
                            anchorOrigin={{
                              vertical: 'bottom',
                              horizontal: 'right',
                            }}
                            badgeContent={[
                              categories(
                                item.profil.photo,
                                item.profil.description,
                                item.is_expert,
                                item.is_speaker
                              ).map((item2, index) => (
                                <Avatar
                                  title={item2.title}
                                  key={index}
                                  className="col"
                                  src={item2.icone}
                                  alt=""
                                  style={{
                                    width: '18px',
                                    height: 'auto',
                                    marginRight: '0',
                                    left: '-5px',
                                    backgroundColor: '  white',
                                  }}
                                />
                              )),
                            ]}
                          >
                            <Avatar
                              id="photoProfil"
                              className=""
                              src={item.photo_path}
                              style={{}}
                            />
                          </Badge>
                        </Col>
                        <Col
                          onClick={() =>
                            item.id === monProfil.id ? '' : participantSelect(accessToken, item.id)
                          }
                          className="mx-1"
                          style={{ cursor: 'pointer' }}
                        >
                          <Row className="noms-participant">
                            {' '}
                            {formatName(item.user.prenom, item.user.nom)}
                          </Row>
                          <Row>{upperFirst(item.fonction.toLowerCase())}</Row>
                          <Row>
                            {item.raison_sociale === undefined ||
                            item.raison_sociale === '' ||
                            item.raison_sociale === null
                              ? !item.from_structure
                                ? upperFirst(item.organisation.nom.toLowerCase())
                                : upperFirst(
                                    item.organisation.adresse_organisation.ville.toLowerCase()
                                  )
                              : upperFirst(item.raison_sociale.toLowerCase())}
                          </Row>
                        </Col>

                        <Col
                          sm="auto"
                          className="d-flex justify-content-end"
                          style={{ width: 'fit-content' }}
                        >
                          {item.is_contact_status === 'accepted' ? (
                            <img
                              src={pictos.demande_valide_icone}
                              alt=""
                              style={{ width: '30px' }}
                            />
                          ) : item.is_contact_status === 'pending' ||
                            (indexPart.filter(value => value === item.id)[0] === item.id &&
                              programmeSelected.intervenants.filter(val => val.id === item.id)[0]
                                .is_contact_status === 'pending') ? (
                            <img
                              src={pictos.demande_attente_icone}
                              alt=""
                              style={{ width: '30px' }}
                            />
                          ) : item.is_contact_status === 'invite' ? (
                            <img
                              title="Ajouter"
                              onClick={() => ouvrirEnvoyer(item.id)}
                              src={pictos.ajout_contact_icone}
                              alt=""
                              style={{ width: '30px', cursor: 'pointer' }}
                            />
                          ) : null}
                        </Col>
                      </Row>
                    ))
                  )}

                  {programmeSelected.intervenants.length ? (
                    <Row className="coordonnee-info"></Row>
                  ) : null}
                </Container>
              </Row>
              {(param.type === '2' || param.type === '1') && (
                <Row className="py-3 d-flex justify-content-end">
                  <Col sm="auto" style={{ width: 'fit-content' }}>
                    {cancelLoading ? (
                      <CircularProgress size={24} />
                    ) : (
                      <MuiButton
                        variant="outlined"
                        color="error"
                        onClick={() => setOpenConfirmCancel(true)}
                        sx={{
                          borderRadius: '50px',
                          borderWidth: '1px',
                          textTransform: 'none',
                          fontFamily: PoliceDefaut,
                        }}
                      >
                        Annuler
                      </MuiButton>
                    )}
                  </Col>
                </Row>
              )}
            </Col>
          </Row>
        </Col>
      </Row>
      <Modal show={openConfirmCancel} onHide={() => setOpenConfirmCancel(false)}>
        <Modal.Header
          closeButton
          closeVariant="white"
          style={{ color: 'white', backgroundColor: '#134491' }}
        >
          <h4>Confirmation</h4>
        </Modal.Header>
        <Modal.Body>
          {param.type === '1'
            ? 'Voulez-vous vraiment retirer ce programme de votre journée ?'
            : 'Voulez-vous vraiment supprimer ce rendez-vous ?'}
          <div className="d-flex justify-content-end mt-3">
            {cancelLoading ? (
              <CircularProgress size={20} />
            ) : (
              <Button className="btn-recup" onClick={handleCancel}>
                Confirmer
              </Button>
            )}
            <Button
              className="btn-recup2 mx-2"
              variant="secondary"
              onClick={() => setOpenConfirmCancel(false)}
            >
              Fermer
            </Button>
          </div>
        </Modal.Body>
      </Modal>
    </Container>
  );
};

export default ProgrammeDetail;
